// src/components/elements/IconEffectWrapper.js
import React from 'react';

const IconEffectWrapper = ({ onClick, children }) => {
  return (
    <button
      onClick={onClick}
      className="text-gray-700 p-2 w-10 h-10 rounded-lg flex items-center justify-center 
                 transition-all duration-300 ease-in-out hover:bg-[var(--brandprimarylight)] hover:shadow-md"
    >
      {children}
    </button>
  );
};

export default IconEffectWrapper;
